import ContactInfo from './ContactInfo'
export default ContactInfo
